import { useState } from 'react';
import { useAuth } from '../contexts/auth-context';
import { postJson, useInvalidate } from '../hooks/useApi';
import { Button, Card, PageHeader } from './ui';
import AccountStatus from './AccountStatus';

// Pagina op /coach-invite?token=… — een coach accepteert de uitnodiging van een
// sporter. Vereist inloggen; daarna wordt de coach-koppeling gemaakt.
export default function CoachAcceptView({ onNavigate }) {
  const { loggedIn, loading, login, user } = useAuth();
  const token = new URLSearchParams(window.location.search).get('token') || '';

  const [busy, setBusy]   = useState(false);
  const [error, setError] = useState(null);
  const [done, setDone]   = useState(null); // athleteName bij succes
  const invalidate = useInvalidate();

  async function accept() {
    setBusy(true); setError(null);
    try {
      const { ok, data } = await postJson('/api/coach-accept', { token });
      if (ok) {
        await invalidate('/api/coach-links');
        setDone(data.athleteName || 'de sporter');
      } else setError(data.error || 'Accepteren mislukt. Controleer de link of vraag de sporter een nieuwe uitnodiging.');
    } catch { setError('Geen verbinding. De uitnodiging kon niet worden geaccepteerd. Probeer opnieuw.'); }
    finally { setBusy(false); }
  }

  function goCoach() {
    if (onNavigate) onNavigate('coach');
    else window.location.assign('/coach');
  }

  return (
    <div className="flex items-center justify-center min-h-[400px] p-4">
      <Card className="w-full max-w-md">
        <div className="flex flex-col gap-4">
        <PageHeader title="Coach-uitnodiging" />

        {!token ? (
          <AccountStatus error="Geen geldige uitnodigingslink. Vraag de sporter een nieuwe link te maken via Profiel → Coaches." />
        ) : done ? (
          <>
            <AccountStatus>Je bent nu gekoppeld als coach van <strong>{done}</strong>. Bekijk rondetijden, live-gegevens en sessienotities in je coachwerkplek.</AccountStatus>
            <Button variant="accent" onClick={goCoach}>Naar coachwerkplek</Button>
          </>
        ) : loading ? (
          <AccountStatus>Account laden…</AccountStatus>
        ) : !loggedIn ? (
          <>
            <p className="text-[16px] text-ink-2 leading-relaxed">Begeleid de sporter met echte rondetijden, hartslag en sessienotities. Log in of maak een account; daarna kun je deze uitnodiging bewust accepteren.</p>
            <Button variant="accent" onClick={login}>Inloggen / account maken</Button>
          </>
        ) : (
          <>
            <div className="text-[15px] text-ink-2 leading-[1.5]">
              Je bent ingelogd als <strong>{user?.name || user?.email}</strong>. Accepteer de uitnodiging om coach te worden.
            </div>
            <AccountStatus error={error} />
            <Button variant="accent" onClick={accept} disabled={busy}>
              {busy ? 'Bezig…' : 'Uitnodiging accepteren'}
            </Button>
          </>
        )}
        </div>
      </Card>
    </div>
  );
}
